import { ReactNode } from 'react';
import { Listing, ListingProps } from './Listing';

export interface ModuleGroupProps {
  /** Identifier */
  id?: string;
  /** Group title */
  title?: string;
  /** Introductory description */
  description?: string | ReactNode;
  /** Items */
  items?: ListingProps['items'];
}

export interface ModulesProps {
  /** Items (single flat list; ignored when groups are given) */
  items?: ListingProps['items'];
  /** Module type groups */
  groups?: ModuleGroupProps[];
  /** Footer */
  footer?: string;
  /** Additional class */
  className?: string;
}

/** A list of modules, optionally structured into module type groups */
export const Modules = ({ items, groups, footer, className }: ModulesProps) => {
  const renderable = (groups ?? [{ items }]).filter(
    (group: ModuleGroupProps) =>
      (group.items && group.items.length > 0) ||
      group.title ||
      group.description,
  );

  if (renderable.length === 0) {
    return null;
  }

  return (
    <div className={['modules', className].join(' ')}>
      {renderable.map((group, index) => (
        <div className="modules__group" key={group.id || index}>
          {group.title && (
            <h4 className="modules__group-title">{group.title}</h4>
          )}
          {group.description && (
            <p className="modules__group-description">{group.description}</p>
          )}
          {group.items && group.items.length > 0 && (
            <Listing
              className="modules__listing"
              type="product"
              list={true}
              items={group.items}
            />
          )}
        </div>
      ))}
      {footer !== undefined && <p className="modules__footer">{footer}</p>}
    </div>
  );
};
